import { INITIAL_EVENT_DURATION_MINUTES } from "modules/event";

export const getInitialEventDurationMS = (eventSettingsTimeLimit: number) =>
  (eventSettingsTimeLimit === -1
    ? INITIAL_EVENT_DURATION_MINUTES
    : Math.min(eventSettingsTimeLimit, INITIAL_EVENT_DURATION_MINUTES)) *
  60 *
  1000;
